export interface Board {
  id: number
  slug: string
  nome: string
  descricao: string | null
  colunas: Coluna[]
  criado_em: string
}

export interface Coluna {
  id: string
  nome: string
  cor: string
}

export interface Card {
  id: number
  board_id: number
  coluna_id: string
  titulo: string
  descricao: string | null
  categoria: string
  prioridade: 'critica' | 'alta' | 'media' | 'baixa'
  tipo: 'tarefa' | 'ideia' | 'pesquisa' | 'decisao' | 'milestone'
  responsavel: string | null
  data_limite: string | null
  data_inicio: string | null
  ordem: number
  tags: string[]
  meta: Record<string, unknown>
  arquivado: boolean
  criado_por: string
  criado_em: string
  atualizado_em: string
  comentarios?: Comentario[]
}

export interface Comentario {
  id: number
  card_id: number
  autor: string
  tipo: 'comentario' | 'movimentacao' | 'edicao' | 'ia_sugestao'
  conteudo: string
  meta: Record<string, unknown>
  criado_em: string
}

export interface Decisao {
  id: number
  card_id: number | null
  numero: number
  titulo: string
  status: 'proposta' | 'aceita' | 'rejeitada' | 'substituida' | 'adiada'
  contexto: string
  opcoes: { nome: string; pros: string[]; contras: string[] }[]
  decisao: string | null
  justificativa: string | null
  consequencias: string | null
  revisao_em: string | null
  tags: string[]
  criado_por: string
  criado_em: string
  atualizado_em: string
}

export interface Pesquisa {
  id: number
  card_id: number | null
  titulo: string
  categoria: string
  resumo: string
  conteudo: string | null
  fontes: { titulo: string; url: string; data_acesso?: string }[]
  dados_chave: Record<string, unknown>
  tags: string[]
  criado_por: string
  criado_em: string
  atualizado_em: string
}

export interface Milestone {
  id: number
  titulo: string
  descricao: string | null
  fase: string
  data_inicio: string | null
  data_alvo: string
  data_conclusao: string | null
  status: 'pendente' | 'em_andamento' | 'concluido' | 'atrasado' | 'cancelado'
  dependencias: number[]
  progresso: number
  cor: string | null
  meta: Record<string, unknown>
  card_ids?: number[]
  cards?: { id: number; titulo: string; coluna_id: string }[]
  criado_por: string
  criado_em: string
  atualizado_em: string
}

export interface DashboardResumo {
  cards_por_coluna_categoria: { coluna_id: string; categoria: string; total: number }[]
  decisoes_por_status: { status: string; total: number }[]
  milestones_por_status: { status: string; fase: string; total: number }[]
  cards_atrasados: number
}

export const CATEGORIAS = [
  { id: 'geral', nome: 'Geral', cor: '#6b7280' },
  { id: 'marketplace', nome: 'Marketplace', cor: '#f59e0b' },
  { id: 'logistica', nome: 'Logistica', cor: '#8b5cf6' },
  { id: 'marketing_digital', nome: 'Marketing', cor: '#ec4899' },
  { id: 'catalogo', nome: 'Catalogo', cor: '#06b6d4' },
  { id: 'financeiro', nome: 'Financeiro', cor: '#10b981' },
  { id: 'tecnologia', nome: 'Tecnologia', cor: '#3b82f6' },
  { id: 'juridico', nome: 'Juridico', cor: '#ef4444' },
  { id: 'atendimento', nome: 'Atendimento', cor: '#14b8a6' },
] as const

export const PRIORIDADES = {
  critica: { nome: 'Critica', cor: '#dc2626' },
  alta: { nome: 'Alta', cor: '#f59e0b' },
  media: { nome: 'Media', cor: '#3b82f6' },
  baixa: { nome: 'Baixa', cor: '#6b7280' },
} as const
